import { useState, useEffect } from "react";
import SearchResult from "./SearchResult/SearchResult";
import SearchInput from "./SearchInput/SearchInput";
import ShowSpecific from "./ShowSpecific/ShowSpecific";
import InfoPage from "./InfoPages/InfoPages.jsx";
import ScrollToTop from "Utils/ScrollToTop";
import PopupForm from "./PopupForm";

import Welcome from "./InfoPages/Welcome";
import Purchases from "./InfoPages/Purchases";
import Service from "./InfoPages/Service";
import Region from "./InfoPages/Region";
import Lifestyle from "./InfoPages/Lifestyle";
import NewsList from "./NewsList";
import News from "./NewsList/News";
import Contact from "./InfoPages/Contact";
import KnowEverything from "./InfoPages/KnowEverything";
import Team from "./Team";
import Magazine from "./GetMagazine";
import VideoList from "./VideoList";
import Events from "./Events";
import Alles from "./InfoPages/Alles";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";

function Content() {
  const [result, setResult] = useState(false);
  const [totalPages, setTotalPages] = useState("");

  const [images, setImages] = useState({ result: {}, slideshow: {} });
  const [text, setText] = useState({});

  useEffect(() => {
    (async () => {
      var txt = await (await fetch("/text/infopages.json")).json();
      setText(txt);
      console.log(txt);
    })();
  }, []);

  function changeTotalPages(total) {
    setTotalPages(total);
  }

  return (
    <div className="content-section container-fluid">
      {/* <PopupForm /> */}
      <ScrollToTop />

      <Switch>
        <Route path="/welcome">
          <Welcome
            key="welcome"
            page="welcome"
            title="Welcome To Vhenga"
            text={text}
          />
        </Route>
        <Route path="/alles">
          <Alles
            key="alles"
            page="alles"
            title="Welcome To Vhenga"
            text={text}
          />
        </Route>
        <Route path="/results">
          <SearchResult
            totalPages={totalPages}
            changeTotalPages={changeTotalPages}
            resultSet={{ value: result, set: setResult }}
            properties={result}
            ImageCache={{ images, setImages }}
            title="Search Results"
          />
          ;
        </Route>
        <Route path="/show">
          <ShowSpecific
            ImageCache={{ images, setImages }}
            title="Show Property"
          />
        </Route>
        <Route path="/team">
          <Team key="team" />
        </Route>

        <Route path="/purchases">
          <Purchases
            key="purchases"
            page="purchases"
            title="Aankopen"
            text={text}
          />
        </Route>
        <Route path="/service">
          <Service key="service" page="service" title="Service" text={text} />
        </Route>
        <Route path="/regio">
          <Region key="regio" page="region" title="Regio" text={text} />
        </Route>
        <Route path="/lifestyle">
          <Lifestyle
            key="lifestyle"
            page="lifestyle"
            title="Lifestyle"
            text={text}
          />
        </Route>
        <Route path="/news">
          <NewsList key="news" page="news" title="News" text={text} />
        </Route>
        <Route path="/videos">
          <VideoList key="videos" title="Videos" text={text} />
        </Route>

        <Route path="/contact">
          <Contact key="contact" page="contact" title="Contact" text={text} />
        </Route>

        <Route path="/knoweverything">
          <KnowEverything
            key="knoweverything"
            page="knoweverything"
            title="Know Everything"
            text={text}
          />
        </Route>
        <Route path="/magazine">
          <Magazine key="magazine" />
        </Route>
        <Route path="/events/:URL_eventsource/:URL_eventside">
          <Events page="events" title="Events" text={text} />
        </Route>
        <Route path="/">
          <SearchInput
            resultSet={{ set: setResult, value: result }}
            page="home"
            title="Search Porperties"
            text={text}
          />
        </Route>
      </Switch>
    </div>
  );
}

export default Content;
